/* src/course_approvals/cards/CourseApprovalListCard/styles.js */

export default theme => ({
  paper: {
    height: theme.spacing.unit * 90,
    overflow: 'auto',
  },
  textField: {
    // top: -theme.spacing.unit * 3,
    width: 200,
  },
});



// WEBPACK FOOTER //
// ./src/modules/course_approvals/cards/CourseApprovalListCard/styles.js